<template>
  <div>
    <Head :title="`${client.name}`" />
    <button class="bg-sky-700 text-white rounded p-2 mr-2" @click="$router.back()">
      <i class="fa fa-arrow-left"></i>
    </button>
    
    <div class="flex justify-between items-center mb-8">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Clientes</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ client.name }}
      </h1>
      <Link :href="`/clients/${client.id}/edit`" class="bg-sky-700 text-white px-4 py-2 rounded">
        Editar Cliente
      </Link>
    </div>

    <!-- Información del Cliente -->
    <div class="bg-white rounded-xl shadow-lg p-6 mb-6">
      <div class="grid grid-cols-2 gap-6">
        <div>
          <h3 class="font-bold mb-2">Información General</h3>
          <p><span class="font-semibold">Empresa:</span> {{ client.companyName }}</p>
          <p><span class="font-semibold">Identificación:</span> {{ client.identification }}</p>
          <p><span class="font-semibold">Email:</span> {{ client.email }}</p>
          <p><span class="font-semibold">Teléfono:</span> {{ client.phone }}</p>
        </div>
        <div>
          <h3 class="font-bold mb-2">Información Financiera</h3>
          <p><span class="font-semibold">Balance:</span> ${{ client.balance }}</p>
          <p><span class="font-semibold">Límite de Crédito:</span> ${{ client.creditLimit }}</p>
        </div>
      </div>
    </div>

    <!-- Historial de Órdenes -->
    <div class="max-w-full bg-white rounded-xl shadow-lg overflow-hidden mb-6">
      <div class="flex items-center justify-between px-8 py-4 bg-sky-700 text-white">
        <span>Historial de Órdenes</span>
        <a :href="`/reports/clients/${client.id}`"
          target="_blank"
          class="bg-white text-sky-700 px-4 py-2 rounded hover:bg-gray-100">
          <i class="fa fa-print mr-2"></i>
          Estado de cuenta
        </a>
      </div>
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">#</th>
          <th class="pb-4 pt-6 px-6">Fecha</th>
          <th class="pb-4 pt-6 px-6">Estado</th>
          <th class="pb-4 pt-6 px-6">Observación</th>
          <th class="pb-4 pt-6 px-6">Total</th>
          <th class="pb-4 pt-6 px-6">Balance</th>
        </tr>
        <tr v-for="order in client.orders" 
            :key="order.id" 
            :class="`hover:bg-gray-100 focus-within:bg-gray-100 ${order.order_state === 'cancel' ? 'bg-red-200' : ''}`">
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              <span v-if="order.order_state == 'estimate'">PRESUPUESTO</span>
              <span v-if="order.order_state == 'cancel'">ANULADA</span>
              <span v-if="order.order_state == 'request'">PENDIENTE POR PAGO</span>
              <span v-if="order.order_state == 'finish'">FINALIZADA</span>
              <span v-if="order.order_state == 'pay'">PAGADA</span>
              <span v-if="order.order_state == 'delivery'">EN TRANSPORTE</span>
              <span v-if="order.order_state == 'picking'">PICKING</span>
              <span v-if="order.order_state == 'packing'">PACKING</span>
              <span v-if="order.order_state == 'dispatch'">EN LOTE DE CARGA</span>
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.comentary }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              ${{ order.total }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`/orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              ${{ order.balance }}
            </Link>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '../../Shared/Layout.vue';
import TextInput from '../../Shared/TextInput.vue';

export default {
  components: {
    Head,
    Link,
    TextInput
  },
  data() {
    return {
        form: {
            amount: '',
            reference: '',
            payment_method: '',
            comentary: '',
            errors: []
        }
    }
  },

  layout: Layout,
  
  props: {
    client: Object
  },
  methods: {
    update() {
      this.form.post(`/order-pays/${this.client.id}`, {
        onSuccess: () => {
          this.form.amount = '';
          this.form.reference = '';
          this.form.payment_method = '';
          this.form.comentary = '';
        }
      });
    }
  }
}
</script>
